module.exports = __webpack_public_path__ + "media/images/pic/brodno/hero-7a6f6b6160eb4ec804113054b67fadf3.svg";